export default __webpack_public_path__ + "static/media/tshare.e33a9641.svg";